export default "__VITE_ASSET__e92beeb6__"